import actions from "./actions";

const initialState = {
  id: "",
  name: "",
  contact: "",
  email: "",
  avatar: "",
  wrong: false,
  authorized: false,
  loading: false,
  is_active: false,
  user: {},
  student_info: {},
  studentData: {},
  student_class: {},
  student_section: {},
  staffData: {},
  role: {},
  session: {},
};

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
